module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_22 More.b915f69c.png";